import fetch from '../fetch'
import { AxiosResponse } from 'axios'
import {
  NextCaseReportRequestParamsType,
  CaseReportId,
  PostCaseReportRespType,
} from '../../models'

export type CaseReportNextParams = {
  caseReportId: CaseReportId
  nextCaseReportParams: NextCaseReportRequestParamsType
}

/**
 * postCaseReportNext
 */
export const postCaseReportNext = ({
  caseReportId,
  nextCaseReportParams,
}: CaseReportNextParams): Promise<AxiosResponse<PostCaseReportRespType>> => {
  const token = localStorage.getItem('token')
  return fetch({
    method: 'POST',
    path: `api/v1/case-report/${caseReportId}/next`,
    data: nextCaseReportParams,
    headers: {
      Authorization: token && `Bearer ${token}`,
    },
  })
}
